import { styled } from 'naan/stitches.config';

export const PricingCardsWrapper = styled('div', {
  width: '100%',
  maxWidth: '380px',
  '& > * + * ': {
    marginTop: '20px',
    '@small': {
      marginTop: '0px',
    },
  },
  '@small': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    gap: '24px',
    maxWidth: 'none',
  },
});
